import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, HashRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AppProvider } from "./AppContext";
import ReactPixel from "react-facebook-pixel";

const root = ReactDOM.createRoot(document.getElementById("root"));
const PIXEL_ID = "2077557522505313"; // Replace with your Pixel ID
// Initialize Facebook Pixel
ReactPixel.init(PIXEL_ID);
ReactPixel.pageView(); // Track initial page view

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <AppProvider>
        <App />
      </AppProvider>
    </BrowserRouter>
  </HelmetProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
